import { ENV } from '@vision/ui/utils';

if (import.meta.env.PROD && ENV.SUPPRESS_CONSOLE_ERRORS) {
  // Overwriting the console.error function in the production
  // environment to prevent error details from being exposed to clients.
  console.error = () => {}; // No-op
}
